import moment from 'moment';
import {
  getPagedProposals,
  updateProposalById,
  createProposal,
} from '../../configs/environments/firebase/firebaseApp';

export const GET_PROPOSALS = 'GET_PROPOSALS';
export const SET_PROPOSAL_SELECTED = 'SET_PROPOSAL_SELECTED';
export const UPDATE_PROPOSAL = 'UPDATE_PROPOSAL';
export const CLEAN_PROPOSAL = 'CLEAN_PROPOSAL';
export const LOAD_PROPOSAL_DATA = 'LOAD_PROPOSAL_DATA';
export const SAVE_PROPOSAL = 'SAVE_PROPOSAL';
export const LOAD_PDF = 'LOAD_PDF';

const proposalsLoad = (data) => {
  return {
    type: GET_PROPOSALS,
    data
  }
}

const setProposal = (data) => {
  return {
    type: SET_PROPOSAL_SELECTED,
    data
  }
}

const updateProposalsLoad = (data) => {
  return {
    type: UPDATE_PROPOSAL,
    data
  }
}

const cleanProposal = () => {
  return {
    type: CLEAN_PROPOSAL,
  }
}

const setProposalData = (data) => {
  return {
    type: LOAD_PROPOSAL_DATA,
    data
  }
}

const loadPdf = (data) => {
  return {
    type: LOAD_PDF,
    data
  }
}

/* ECONOMIC PROPOSALS */
export const getProposalsByPage = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (params) {
      if (params.createdAt) {
        params['createdAt'] = moment(params.createdAt).unix();
      }
      getPagedProposals(params)
        .then((res) => {
          dispatch(proposalsLoad(res.data));
          return resolve('success');
        })
        .catch((err) => reject(err));
    } else {
      return reject('fail');
    }
  });
};

export const setProposalSelected = proposalData => dispatch => {
  dispatch(setProposal(proposalData))
};

export const updateProposal = (item, list, uid) => (dispatch) => {
  return new Promise((resolve, reject) => {

    const mappedProposals = list.data.map(elem => {
      if (elem.id === item.id) {
        return elem = {
          ...item
        }
      }
      return elem
    })

    const newProposals = {
      ...list,
      data: mappedProposals
    }

    //Get key-values from item and filter all different from 'createAt'. Create body for query.
    let body = Object.entries(item).filter(prop => ( prop[0] !== 'createdAt' && prop[0] !== 'id'))
    console.log('body update', body)
    updateProposalById(Object.fromEntries(body), item.id, uid)
      .then((res) => {
        dispatch(updateProposalsLoad({
          item,
          list: newProposals
        }));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const deleteProposal = (item, list, uid) => (dispatch) => {
  return new Promise((resolve, reject) => {

    const mappedProposals = list.data.filter(elem => (elem.id !== item.id))

    const newProposals = {
      ...list,
      data: mappedProposals
    }

    //Get key-values from item and filter all different from 'createAt'. Create body for query.
    let body = Object.entries(item).filter(prop => ( prop[0] !== 'createdAt' && prop[0] !== 'id'))
    console.log('body', body)

    updateProposalById(Object.fromEntries(body), item.id, uid)
      .then((res) => {
        dispatch(updateProposalsLoad({
          item,
          list: newProposals
        }));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const cleanProposalData = () => dispatch => {
  dispatch(cleanProposal());
}

export const loadProposalData = (proposalData) => dispatch => {
  dispatch(setProposalData(proposalData));
}

export const saveProposalData = (body, uid) => dispatch => {
  return new Promise((resolve, reject) => {
  createProposal(body, uid)
    .then((res) => {
      dispatch(setProposalData(body))
      return resolve(res)
    })
    .catch(err => reject(err))
  });
}

export const getPdf = (data) => dispatch => {
  dispatch(loadPdf(data));
}